import React from 'react'

const GlobalLoader = () => {
  return (
    <div className="loader-main">
      <div className="main_box">
        <div className="line1"></div>
        <div className="line2"></div>
        <div className="line3"></div>
        <div className="line4"></div>
      </div>
    </div>
  )
}

export default GlobalLoader